import { useTranslation } from "react-i18next";
import Layout from "src/components/layout/Layout";
import useGet from "src/hooks/rest/useGet";
import useAuth from "src/hooks/selectors/useAuth";
import DashboardCompanyView from "src/views/authenticated/dashboard/DashboardCompanyView";
import DashboardStudentView from "src/views/authenticated/dashboard/student/DashboardStudentView";

const DashboardView = () => {
	const auth = useAuth();
	const { t } = useTranslation(["alerts"]);
	const { type } = auth;
	const [{ data }, loading] = useGet(`/${type}/statistics`);

	if (type === "company") {
		return (
			<DashboardCompanyView
				{...{ loading }}
				messages={data?.today?.messages || 0}
			/>
		);
	}

	if (type === "student") {
		return <DashboardStudentView />;
	}

	return (
		<Layout loading={loading}>
			<div className="flex flex-col justify-center items-center flex-1">
				<h2>{t("something-wrong")}</h2>
			</div>
		</Layout>
	);
};

export default DashboardView;
